import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { bulkDisputeSampleCSV } from '../../../services/externalDispute';
import { fetchClientList } from '../../../services/externalDispute';
import CryptoJS from 'crypto-js';
import { getReasonSubReason } from '../../../services/externalDispute';
import { variables } from '../../../../config'


export default {
  name: 'DisputeBulkUpload',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      isLoading1: false,
      bulkCSVData:[],
      username:'',
      attachment:[],
      FileSelected: null,
      bulkDisputeCSVData:[],
      FailedRecords:'',
      FailedRecords:'',
      bulkDisputeCSVDataFlag:false,
      clientList:[],
      client:'',
      userFirstLastName : '',
      shipmentTypeList : ["DTO","RTO","DTODispute","Forward"],
      dtoReasonSub : [],
      rtoReasonSub : [],
      dtoDisputeReasonSub : [],
      forwardDispReasonSub : [],
      bulkModal : false,
      bulkLoader : false,
         activeTab: 0,
    awbnumber:'',
    clienList:[],
     StatusTypeList: [{id:'38', label: 'Draft Dispute'}],
    DisputeStatus:'',
     todate: '',
      fromdate: '',
      listUserData:[],
      totalcount:0,
      pageno: 0,
      editshowtable: false,
      verification:'',
      pagecount: 1,
      formKey: 0 // key used to force re-render

      //requiredColumns: ["ShippingID","ShipmentType","DisputeAmount","DisputeReason","DisputeSubReason","Comments","UnboxingVideo","PhotoProof-1","PhotoProof-2", "PhotoProof-3", "PhotoProof-4","OtherProof-1","OtherProof-2","DisputeRemark"]

    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.fetchClient()
    var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userFirstLastName = userdetail.FirstName
    this.reasonSubReason();
     variables.pageRecordLimit = 50;
    this.verificationStatusName()

  },
  computed: {

  },

  methods: {
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata
      },
        error => {

          console.error(error)
        })

    },
    resetForm() {
      this.hub = '';
      this.newhubs = '';
      this.todate = '';
      this.fromdate = '';
      this.octroi_MRP = '';
      this.awbnumber = '';
      this.isLoading = false;
      this.editshowtable = false;
      this.isLoading1 = false;
      this.$validator.reset(); this.errors.clear();
    },

    getClientList() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getClientList',
        data: {},
        headers: {
          Authorization: 'Bearer ' + this.myStr,
        },
      }).then((result) => {
        this.clienList = result.data.data;
        this.editshowtable = false;
        for (let j = 0; j < this.listUserData.length; j++) {
          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j].clientid !== null
              && this.listUserData[j].clientid !== undefined) {
              if (this.clienList[i].ClientMasterID === this.listUserData[j].clientid) {
                this.listUserData[j].Clientname = this.clienList[i].CompanyName;
              }
            }
          }
        }
        this.editshowtable = true;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },
    verificationStatusList() {      
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {      
        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {


            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["lastactionname"] = this.verification[i]["label"];
            }
          }
        }
      }
      this.editshowtable = true;
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    // to get pagination
    getPaginationData(pageNum) {   
      console.log(pageNum,"aswertyuikuytrew");
      this.searchResults(pageNum);
    },
    // searchbutton
    searchResults(pageNo) {
      this.isLoading1 = true;
      this.show2 = true,
        this.listUserData = [];
            this.pagecount = 1;
      this.totalcount = 0;
        this.input = ({
          page: pageNo,
          limit: variables.pageRecordLimit, 
        });
        if (this.awbnumber !== '') {
        this.input.shippingid = this.awbnumber;
}
      if (this.DisputeStatus !== '') {
      this.input.disputestatus = this.DisputeStatus.id;
}
        axios({
          method: 'post',
          url: `${apiUrl.api_url}getdisputedetails`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          this.show2 = false,
          this.totalcount = result.data.count?result.data.count:0
          if (this.totalcount == undefined) {
            this.totalcount = 0
          }
          this.listUserData = result.data.data;          
          this.getClientList();
          this.buckettypecode();
         this.verificationStatusList();
          if (this.totalRows < variables.pageRecordLimit) {
             console.log(result.data.count,"fghjhgfdswdefrgt");

            this.pagecount = 1;
          } else {
               console.log(result.data.count,"else");
            this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit);
          
          }
        });
    },

  resetFilters() {
  this.DisputeStatus='',
  this.awbnumber='',
  this.listUserData = [];
  this.pagecount = 1;
    this.pageno = 0; this.totalcount = ''; 
  this.formKey += 1; // 👈 this triggers the re-render
  },
 
  confirmShipment(shippingid) {
      this.input = ({
        actiontakenby:localStorage.getItem("username"),
        isactionstatus:false,
        actiontakendate:moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"),
        shippingid:shippingid,
      });
     
      axios({
        method: 'post',
        url: apiUrl.api_url + 'updateManualDeliveryShipment',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        if (result.data.statusCode == 200) {          
          this.$alertify.success(result.data.message)
           this.searchResults(); // Replace with your actual fetch method

        }
        else {
          this.$alertify.error(result.data.message)
        }

      })
    },
    fetchClient(){
      fetchClientList({}, this.myStr).then(client => {
        let clienList = client.data.data;
        this.clientList = clienList.map(client => ({id: client.ClientMasterID, label: client.CompanyName}));
            })
    },
    async exportfileCSV() {
      this.isLoading1 = true;
      let bulkData=await bulkDisputeSampleCSV(this.myStr)
      this.bulkCSVData=bulkData.data.ReturnCSV
      this.downloadCSV(this.bulkCSVData);
    },

    async downloadCSV(result) {
      var csvData = result;
      var data, filename, link;
      filename = "bulkDisputeSampleCSV" +".csv";
      var csv = await this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = csv;
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      lineDelimiter = args.lineDelimiter || "\n";
      columnDelimiter = args.data
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      return result;
    },
    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('createdBy', this.username);
            // form.append('ClientID', this.client.id);
            form.append('username',this.userFirstLastName)
            var inputpayload = form;
            this.bulkModal = true
            this.bulkLoader = true
            axios({
              method: 'post',
              url: `${apiUrl.api_url}uploadBulkDisputeCSV`,
              data: inputpayload,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              },
            }).then((result) => {
              if (result.data.ReturnCode !== 100) this.$alertify.error(result.data.ReturnMessage);
              if (result.data.ReturnCode === 100){
              this.bulkDisputeCSVData=result.data.FailedRecords
              this.bulkDisputeCSVDataFlag=true
              this.successData=result.data.Success
              this.FailedRecords=result.data.Failures
            }
            this.bulkModal = false
            this.bulkLoader = false
            },
              (error) => {
                this.show = false;
                this.displaytable = false;
                this.bulkModal = false
                this.bulkLoader = false
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
    },
 confirmShipment(awb,clientId,actionstatuscode) {
      // localStorage.removeItem('operationpageData')
      this.$router.push({ path: '/EditSingleDispute', query: { awb: awb, clientId: clientId ,actionstatuscode:actionstatuscode} });
    },
    async reasonSubReason() {
      let input = {
        "disputeRaisedType": "Client"
      }
      let taskTypeLength = this.shipmentTypeList.length
      for (let i = 0; i < taskTypeLength; i++) {
        input.taskType = this.shipmentTypeList[i]
        let apiResponse = await getReasonSubReason(input, this.myStr)
        
        if (apiResponse.data.code == 200){
          let resArray = []
          let reasonSubreasonData = apiResponse.data.data
          let reasonSublength = reasonSubreasonData.length
          for (let i = 0; i < reasonSublength; i++) {
            reasonSubreasonData[i].subReason.forEach((sub) => {
              resArray.push({
                reason: reasonSubreasonData[i].reason,
                subreason: sub.subReason
              });
            })
          }
          if (input.taskType == 'DTO'){
            this.dtoReasonSub = resArray
          }else if (input.taskType == 'RTO'){
            this.rtoReasonSub = resArray
          }else if (input.taskType == 'DTODispute'){
            this.dtoDisputeReasonSub = resArray
          }else if (input.taskType == 'Forward'){
            this.forwardDispReasonSub = resArray
            
          }
        }else{
          this.$alertify.error("Dispute Reason Subreason error");
        }

      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/loggedSingleDispute/loggedSingleDispute.component.js